import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapService } from 'src/app/services/map/map.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { VehicleService } from 'src/app/services/vehicle/vehicle.service';
import { VehicleImageFallbackDirective } from 'src/app/directives/vehicle-image-fallback.directive';

@Component({
  standalone: true,
  selector: 'app-vehicle-header',
  templateUrl: './vehicle-header.component.html',
  styleUrls: ['./vehicle-header.component.scss'],
  imports: [CommonModule, VehicleImageFallbackDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleHeaderComponent {

  @Input() navigation: boolean = false;
  @Input() selectedCarNameString: string = '';
  @Input() selectedCarMultilineString: string = '';
  @Input() manageVehicles: boolean = false;

  constructor(
    public mapService: MapService,
    private readonly settingsService: SettingsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly destroyRef: DestroyRef,
    public vehicleService: VehicleService
  ) {
  }
}
